/* DEPRECATED */
import React from 'react';
import classnames from 'classnames';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { get, sortBy, isEmpty } from 'lodash';
import moment from 'moment';

import formField from 'Components/frameworks/form-field/FormField.jsx';

const dayDefaultStruct = {
  ref: 'day',
  stateName: 'dayValue',
  placeholderPropName: 'dayPlaceholder',
  maxLength: 2,
  onChange: null,
  placeholder: null,
};
const monthDefaultStruct = {
  ref: 'month',
  stateName: 'monthValue',
  placeholderPropName: 'monthPlaceholder',
  maxLength: 2,
  onChange: null,
  placeholder: null,
};
const yearDefaultStruct = {
  ref: 'year',
  stateName: 'yearValue',
  placeholderPropName: 'yearPlaceholder',
  maxLength: 4,
  onChange: null,
  placeholder: null,
};
const datePatterns = [
  { key: 'd', struct: dayDefaultStruct },
  { key: 'm', struct: monthDefaultStruct },
  { key: 'y', struct: yearDefaultStruct },
];

const FormInputTelDate = createReactClass({
  propTypes: {
    dateFormat: PropTypes.string,
    dataSelector: PropTypes.string,
    defaultValue: PropTypes.string,
    height: PropTypes.string,
    id: PropTypes.string,
    isActive: PropTypes.bool,
    isDisabled: PropTypes.bool,
    isReadOnly: PropTypes.bool,
    isRequired: PropTypes.bool,
    maxLength: PropTypes.number,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    onClear: PropTypes.func,
    onClick: PropTypes.func,
    onFocus: PropTypes.func,
    onKeyDown: PropTypes.func,
    onKeyUp: PropTypes.func,
    pattern: PropTypes.string,
    placeholder: PropTypes.string,
  },

  getDefaultProps() {
    return {
      dateFormat: 'DDMMYYYY',
      dataSelector: 'FormInputTelDate',
      isActive: false,
      isDisabled: false,
      isReadOnly: false,
      isRequired: false,
      onBlur() {},
      onChange() {},
      onClear() {},
      onClick() {},
      onKeyDown() {},
      onKeyUp() {},
    };
  },

  getInitialState() {
    const formattedDate = moment(this.props.value, this.props.dateFormat);
    return this.props.value && formattedDate.isValid()
      ? {
          dayValue: formattedDate.format('DD'),
          monthValue: formattedDate.format('MM'),
          yearValue: formattedDate.format('YYYY'),
        }
      : {
          dayValue: '',
          monthValue: '',
          yearValue: '',
        };
  },

  areAllInputsFilled() {
    return (
      this.state.dayValue.length === dayDefaultStruct.maxLength &&
      this.state.monthValue.length === monthDefaultStruct.maxLength &&
      this.state.yearValue.length === yearDefaultStruct.maxLength
    );
  },

  getFormattedDate() {
    if (
      isEmpty(this.state.yearValue) &&
      isEmpty(this.state.monthValue) &&
      isEmpty(this.state.dayValue)
    ) {
      return '';
    }
    return this.areAllInputsFilled()
      ? moment([+this.state.yearValue, +this.state.monthValue - 1, +this.state.dayValue]).format(
          this.props.dateFormat,
        )
      : moment.invalid().toString();
  },

  handleChange(value, event, nextInput, maxLength) {
    this.setState(
      {
        [value]: event.target.value,
      },
      () => {
        this.props.onChange(this.getFormattedDate());
      },
    );

    if (nextInput && maxLength && event.target.value.length === maxLength) {
      ReactDOM.findDOMNode(nextInput).focus();
    }
  },

  handleBlur(value, event, nextInput) {
    if (
      !nextInput ||
      get(event, 'relatedTarget.className', '').indexOf('FormInputTelDate-input') === -1
    ) {
      this.props.onBlur(this.getFormattedDate());
    }
  },

  getHandleChangeFunction(field, nextRef, maxLength) {
    return event => this.handleChange(field, event, nextRef, maxLength);
  },

  getHandleBlurFunction(field, nextRef) {
    return event => this.handleBlur(field, event, nextRef);
  },

  buildFormatStructure({ struct, size }, index, patterns) {
    const nextRef =
      index + 1 < patterns.length ? get(this.refs, patterns[index + 1].struct.ref) : null;
    return {
      ...struct,
      id: `${this.props.id}-${index}`,
      maxLength: size,
      onChange: this.getHandleChangeFunction(struct.stateName, nextRef, size),
      onBlur: this.getHandleBlurFunction(struct.stateName, nextRef),
      placeholder: get(this.props, struct.placeholderPropName),
    };
  },

  getPatternPos(dateFormat) {
    return datePattern => ({ ...datePattern, pos: dateFormat.indexOf(datePattern.key) });
  },

  getPatternSize(dateFormat) {
    return datePattern => ({
      ...datePattern,
      size: (dateFormat.match(new RegExp(datePattern.key, 'g')) || []).length,
    });
  },

  getDateStructure(dateFormat) {
    return sortBy(datePatterns.map(this.getPatternPos(dateFormat)), ['pos'])
      .map(this.getPatternSize(dateFormat))
      .map(this.buildFormatStructure);
  },

  render() {
    const structures = this.getDateStructure(this.props.dateFormat.toLowerCase());
    return (
      <div
        className="flex rtl:flex-row items-center text-base w-full"
        data-selector={this.props.dataSelector}
        onFocus={this.props.onFocus ? this.props.onFocus : null}
      >
        {structures.map((structure, index) => {
          return (
            <div
              className="decorator-slash-separator flex flex-1 items-center"
              key={`${this.state[structure.id]}-${index}`}
            >
              <input
                className={classnames('reset-input bg-transparent text-center w-full', {
                  'cursor-not-allowed': this.props.isDisabled,
                  'cursor-progress': this.props.isLoading && !this.props.isDisabled,
                })}
                disabled={this.props.isDisabled}
                id={this.state[structure.id]}
                maxLength={structure.maxLength}
                onBlur={structure.onBlur}
                onChange={structure.onChange}
                placeholder={structure.placeholder}
                ref={structure.ref}
                style={{
                  height: this.props.height,
                }}
                type="tel"
                value={this.state[structure.stateName]}
              />
            </div>
          );
        })}
      </div>
    );
  },
});

export default formField(FormInputTelDate);
